// extracted by mini-css-extract-plugin
export default {"button":"Button_button__KWWE9","wide":"Button_wide__9iOq8"};